import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, " This should be done only when all request documentation has been prepared and submitted to the relevant state office. ", -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, "This should be done only when all request documentation has been prepared.", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, "This may incur mailing / processing fees.", -1);
const _hoisted_4 = { class: "is-danger" };
const _hoisted_5 = { class: "pt-2" };
const _hoisted_6 = { class: "is-danger" };
const _hoisted_7 = { class: "pt-2" };
const _hoisted_8 = { class: "is-danger" };
const _hoisted_9 = { class: "pt-2" };
const _hoisted_10 = { class: "is-danger" };
const _hoisted_11 = { class: "pt-2" };
const _hoisted_12 = { class: "is-danger" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, "This should be done only when you have received the approved record.", -1);
const _hoisted_14 = { class: "is-danger" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, " This should be done only when you have confirmed that the citizen has received their record. ", -1);
const _hoisted_16 = { class: "pt-2" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, " This should be done only to manually correct administrative errors (for example, if an application was mistakenly cancelled, or marked as complete). ", -1);
import { RequestStatus } from "@/features/applications/model";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ApplicationModalDialogCollection',
    props: {
        showChangeStatusConfirmation: {},
        applicationTypeName: {}
    },
    emits: ["clearConfirmationStatus", "doChangeRequestStatus"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_ModalDialog, {
                    active: _ctx.showChangeStatusConfirmation == _unref(RequestStatus).SUBMITTED,
                    title: "Mark Request As Submitted",
                    severity: "link",
                    allowClose: true,
                    onClose: _cache[0] || (_cache[0] = ($event) => (emit('clearConfirmationStatus'))),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[1] || (_cache[1] = ($event) => (emit('clearConfirmationStatus'))),
                    secondButtonText: "Mark As Submitted",
                    secondButtonSeverity: "success",
                    onSecondbuttonselected: _cache[2] || (_cache[2] = ($event) => (emit('doChangeRequestStatus', _unref(RequestStatus).SUBMITTED)))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", null, [
                            _createElementVNode("strong", null, " Do you wish to mark this " + _toDisplayString(_ctx.applicationTypeName) + " request as submitted? ", 1)
                        ]),
                        _hoisted_1
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: _ctx.showChangeStatusConfirmation == _unref(RequestStatus).READY_TO_SUBMIT,
                    title: "Mark Request As Ready to Submit",
                    severity: "link",
                    allowClose: true,
                    onClose: _cache[3] || (_cache[3] = ($event) => (emit('clearConfirmationStatus'))),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[4] || (_cache[4] = ($event) => (emit('clearConfirmationStatus'))),
                    secondButtonText: "Mark As Ready to Submit",
                    secondButtonSeverity: "success",
                    onSecondbuttonselected: _cache[5] || (_cache[5] = ($event) => (emit('doChangeRequestStatus', _unref(RequestStatus).READY_TO_SUBMIT)))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", null, [
                            _createElementVNode("strong", null, " Do you wish to mark this " + _toDisplayString(_ctx.applicationTypeName) + " request as ready to submit? ", 1)
                        ]),
                        _hoisted_2,
                        _hoisted_3
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: _ctx.showChangeStatusConfirmation == _unref(RequestStatus).DOCS_REQUIRED,
                    title: "Mark Request As Documents Required",
                    severity: "link",
                    allowClose: true,
                    onClose: _cache[6] || (_cache[6] = ($event) => (emit('clearConfirmationStatus'))),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[7] || (_cache[7] = ($event) => (emit('clearConfirmationStatus'))),
                    secondButtonText: "Mark As Documents Required",
                    secondButtonSeverity: "success",
                    onSecondbuttonselected: _cache[8] || (_cache[8] = ($event) => (emit('doChangeRequestStatus', _unref(RequestStatus).DOCS_REQUIRED)))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_4, [
                            _createElementVNode("strong", null, "Do you wish to mark this " + _toDisplayString(_ctx.applicationTypeName) + " request as Documents Required?", 1)
                        ]),
                        _createElementVNode("p", _hoisted_5, "This should be done only when the " + _toDisplayString(_ctx.applicationTypeName) + " request requires additional documents or information.", 1)
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: _ctx.showChangeStatusConfirmation == _unref(RequestStatus).NOTARY_REQUIRED,
                    title: "Mark Request As Notary Required",
                    severity: "link",
                    allowClose: true,
                    onClose: _cache[9] || (_cache[9] = ($event) => (emit('clearConfirmationStatus'))),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[10] || (_cache[10] = ($event) => (emit('clearConfirmationStatus'))),
                    secondButtonText: "Mark As Notary Required",
                    secondButtonSeverity: "success",
                    onSecondbuttonselected: _cache[11] || (_cache[11] = ($event) => (emit('doChangeRequestStatus', _unref(RequestStatus).NOTARY_REQUIRED)))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_6, [
                            _createElementVNode("strong", null, "Do you wish to mark this " + _toDisplayString(_ctx.applicationTypeName) + " request as Norary Required?", 1)
                        ]),
                        _createElementVNode("p", _hoisted_7, "This should be done only when the " + _toDisplayString(_ctx.applicationTypeName) + " request requires notarization.", 1)
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: _ctx.showChangeStatusConfirmation == _unref(RequestStatus).APPOINTMENT_REQUIRED,
                    title: "Mark Request As Appointment Required",
                    severity: "link",
                    allowClose: true,
                    onClose: _cache[12] || (_cache[12] = ($event) => (emit('clearConfirmationStatus'))),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[13] || (_cache[13] = ($event) => (emit('clearConfirmationStatus'))),
                    secondButtonText: "Mark As Appointment Required",
                    secondButtonSeverity: "success",
                    onSecondbuttonselected: _cache[14] || (_cache[14] = ($event) => (emit('doChangeRequestStatus', _unref(RequestStatus).APPOINTMENT_REQUIRED)))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_8, [
                            _createElementVNode("strong", null, "Do you wish to mark this " + _toDisplayString(_ctx.applicationTypeName) + " request as Appointment Required?", 1)
                        ]),
                        _createElementVNode("p", _hoisted_9, "This should be done only when the " + _toDisplayString(_ctx.applicationTypeName) + " request requires the citizen to attend an in-person appointment.", 1)
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: _ctx.showChangeStatusConfirmation == _unref(RequestStatus).REJECTED,
                    title: "Mark Request As Rejected",
                    severity: "link",
                    allowClose: true,
                    onClose: _cache[15] || (_cache[15] = ($event) => (emit('clearConfirmationStatus'))),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[16] || (_cache[16] = ($event) => (emit('clearConfirmationStatus'))),
                    secondButtonText: "Confirm Rejection",
                    secondButtonSeverity: "success",
                    onSecondbuttonselected: _cache[17] || (_cache[17] = ($event) => { emit('doChangeRequestStatus', _unref(RequestStatus).REJECTED); })
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_10, [
                            _createElementVNode("strong", null, " Do you wish to mark this " + _toDisplayString(_ctx.applicationTypeName) + " request as rejected? ", 1)
                        ]),
                        _createElementVNode("p", _hoisted_11, "This should be done only when the " + _toDisplayString(_ctx.applicationTypeName) + " request has been rejected.", 1)
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: _ctx.showChangeStatusConfirmation == _unref(RequestStatus).APPROVED,
                    title: "Mark Request As Approved",
                    severity: "link",
                    allowClose: true,
                    onClose: _cache[18] || (_cache[18] = ($event) => (emit('clearConfirmationStatus'))),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[19] || (_cache[19] = ($event) => (emit('clearConfirmationStatus'))),
                    secondButtonText: "Confirm Approved",
                    secondButtonSeverity: "success",
                    onSecondbuttonselected: _cache[20] || (_cache[20] = ($event) => { emit('doChangeRequestStatus', _unref(RequestStatus).APPROVED); })
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_12, [
                            _createElementVNode("strong", null, " Do you wish to mark this " + _toDisplayString(_ctx.applicationTypeName) + " request as approved? ", 1)
                        ]),
                        _hoisted_13
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: _ctx.showChangeStatusConfirmation == _unref(RequestStatus).DELIVERED,
                    title: "Mark Request As Delivered",
                    severity: "link",
                    allowClose: true,
                    onClose: _cache[21] || (_cache[21] = ($event) => (emit('clearConfirmationStatus'))),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[22] || (_cache[22] = ($event) => (emit('clearConfirmationStatus'))),
                    secondButtonText: "Confirm Delivery",
                    secondButtonSeverity: "success",
                    onSecondbuttonselected: _cache[23] || (_cache[23] = ($event) => { emit('doChangeRequestStatus', _unref(RequestStatus).DELIVERED); })
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_14, [
                            _createElementVNode("strong", null, " Do you wish to mark this " + _toDisplayString(_ctx.applicationTypeName) + " request as delivered? ", 1)
                        ]),
                        _hoisted_15
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: _ctx.showChangeStatusConfirmation == _unref(RequestStatus).CANCELLED,
                    title: "Cancel Request",
                    severity: "danger",
                    allowClose: true,
                    onClose: _cache[24] || (_cache[24] = ($event) => (emit('clearConfirmationStatus'))),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[25] || (_cache[25] = ($event) => (emit('clearConfirmationStatus'))),
                    secondButtonText: "Cancel Request",
                    secondButtonSeverity: "danger",
                    onSecondbuttonselected: _cache[26] || (_cache[26] = ($event) => (emit('doChangeRequestStatus', _unref(RequestStatus).CANCELLED)))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", null, [
                            _createElementVNode("strong", null, " Do you wish to cancel this " + _toDisplayString(_ctx.applicationTypeName) + " request? ", 1)
                        ]),
                        _createElementVNode("p", _hoisted_16, " A new request will need to be created from scratch if a " + _toDisplayString(_ctx.applicationTypeName) + " request is later required for this citizen. ", 1)
                    ]),
                    _: 1
                }, 8, ["active"]),
                _createVNode(_component_ModalDialog, {
                    active: _ctx.showChangeStatusConfirmation == _unref(RequestStatus).NEW,
                    title: "Revert Request To New Status",
                    severity: "danger",
                    allowClose: true,
                    onClose: _cache[27] || (_cache[27] = ($event) => (emit('clearConfirmationStatus'))),
                    firstButtonText: "Go Back",
                    firstButtonSeverity: "link",
                    onFirstbuttonselected: _cache[28] || (_cache[28] = ($event) => (emit('clearConfirmationStatus'))),
                    secondButtonText: "Mark As New",
                    secondButtonSeverity: "danger",
                    onSecondbuttonselected: _cache[29] || (_cache[29] = ($event) => (emit('doChangeRequestStatus', _unref(RequestStatus).NEW)))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("p", null, [
                            _createElementVNode("strong", null, " Do you wish to re-open this " + _toDisplayString(_ctx.applicationTypeName) + " request, marking it as new? ", 1)
                        ]),
                        _hoisted_17
                    ]),
                    _: 1
                }, 8, ["active"])
            ], 64));
        };
    }
});
